import type { RouteLocationRaw } from 'vue-router'
import { companyProfileRoute } from './company-route'

type CompanyUserRouteContext = {
  name: string | null | undefined
  companyId: string | undefined
  slug: string
}

type CompanyUserContext = {
  role: string | null
  company_id: string | number | null
}

export const companyUserRedirect = (to: CompanyUserRouteContext, user: CompanyUserContext): RouteLocationRaw | null => {
  if (user.role !== 'company_user') return null

  if (to.name === 'companies.list') {
    if (user.company_id) return companyProfileRoute(to.slug, user.company_id)
    return { name: 'companies.onboarding', params: { slug: to.slug } }
  }

  if (to.name === 'companies.deal_new' || to.name === 'companies.deal_edit') {
    if (user.company_id) return companyProfileRoute(to.slug, user.company_id)
    return { name: 'companies.onboarding', params: { slug: to.slug } }
  }

  if (
    to.name?.startsWith('companies.') &&
    to.companyId &&
    user.company_id &&
    to.companyId !== String(user.company_id)
  ) {
    return { name: 'not-found' }
  }

  return null
}
